//This is webapp version currently used
export const version = {
  value: '1.3.0',
};
